import { useUsersContext } from 'Context/UsersContext';

export const useUsers = () => useUsersContext();
